/**
 * Bộ icon lấy nguyên từ `assets/app.js` của prototype để giữ đúng nét vẽ.
 * Mọi icon là stroke 1.6, viewBox 0 0 20 20, dùng `currentColor`.
 */

const PATHS: Record<string, string> = {
  overview: '<path d="M3 9.5 10 4l7 5.5V16a1 1 0 0 1-1 1h-3.5v-4.5h-5V17H4a1 1 0 0 1-1-1z"/>',
  domains:
    '<circle cx="10" cy="10" r="7"/><path d="M3 10h14M10 3c2 2.2 3 4.6 3 7s-1 4.8-3 7c-2-2.2-3-4.6-3-7s1-4.8 3-7z"/>',
  dns: '<path d="M4 5.5h12M4 10h12M4 14.5h12"/><circle cx="7" cy="5.5" r="1.3" fill="currentColor" stroke="none"/><circle cx="12" cy="10" r="1.3" fill="currentColor" stroke="none"/><circle cx="9" cy="14.5" r="1.3" fill="currentColor" stroke="none"/>',
  users:
    '<circle cx="8" cy="7" r="2.8"/><path d="M3 16.5c0-2.6 2.2-4.2 5-4.2s5 1.6 5 4.2"/><path d="M13.5 5.6a2.6 2.6 0 0 1 0 4.9M14.6 12.6c1.7.5 2.9 1.8 2.9 3.9"/>',
  shield:
    '<path d="M10 3 4.5 5.2v4.4c0 3.3 2.2 6.3 5.5 7.4 3.3-1.1 5.5-4.1 5.5-7.4V5.2z"/><path d="m7.6 10.2 1.7 1.7 3.2-3.4"/>',
  settings:
    '<circle cx="10" cy="10" r="2.6"/><path d="M10 2.6v2M10 15.4v2M17.4 10h-2M4.6 10h-2M15.2 4.8l-1.4 1.4M6.2 13.8l-1.4 1.4M15.2 15.2l-1.4-1.4M6.2 6.2 4.8 4.8"/>',
  profile: '<circle cx="10" cy="7" r="3"/><path d="M3.8 17c.5-3.2 3-5 6.2-5s5.7 1.8 6.2 5"/>',
  audit:
    '<path d="M5 3.5h7l3.5 3.5v9.5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1z"/><path d="M11.6 3.6v3.6h3.6M6.8 11h6.4M6.8 13.8h4.2"/>',
  plus: '<path d="M10 4.5v11M4.5 10h11"/>',
  search: '<circle cx="9" cy="9" r="5.2"/><path d="m13 13 3.4 3.4"/>',
  sun: '<circle cx="10" cy="10" r="3.4"/><path d="M10 2.4v1.8M10 15.8v1.8M17.6 10h-1.8M4.2 10H2.4M15.4 4.6l-1.3 1.3M5.9 14.1l-1.3 1.3M15.4 15.4l-1.3-1.3M5.9 5.9 4.6 4.6"/>',
  moon: '<path d="M16 11.6A6.4 6.4 0 0 1 8.4 4a6.6 6.6 0 1 0 7.6 7.6z"/>',
  // OQ-288 — chế độ giao diện "tự động" (theo hệ điều hành).
  monitor:
    '<rect x="2.6" y="3.6" width="14.8" height="10" rx="1.6"/><path d="M7 16.4h6M10 13.6v2.8"/>',
  bell: '<path d="M6 8.4a4 4 0 0 1 8 0c0 3.4 1.2 4.4 1.2 4.4H4.8S6 11.8 6 8.4z"/><path d="M8.6 15.6a1.6 1.6 0 0 0 2.8 0"/>',
  menu: '<path d="M3.5 6h13M3.5 10h13M3.5 14h13"/>',
  edit: '<path d="M13.2 3.9 16 6.7 7.7 15H5v-2.7z"/>',
  trash:
    '<path d="M4.6 6h10.8M8 6V4.6h4V6M6.2 6l.6 9.4a1 1 0 0 0 1 .9h4.4a1 1 0 0 0 1-.9L13.8 6"/>',
  more: '<circle cx="5" cy="10" r="1.2" fill="currentColor" stroke="none"/><circle cx="10" cy="10" r="1.2" fill="currentColor" stroke="none"/><circle cx="15" cy="10" r="1.2" fill="currentColor" stroke="none"/>',
  copy: '<rect x="7" y="7" width="9" height="9" rx="1.5"/><path d="M13 4.8H5.5A1.5 1.5 0 0 0 4 6.3V13"/>',
  check: '<path d="m4.6 10.4 3.4 3.4 7.4-7.6"/>',
  info: '<circle cx="10" cy="10" r="7"/><path d="M10 9.2v4.2M10 6.6v.9"/>',
  warn: '<path d="M10 3.6 17 16H3z"/><path d="M10 8.4v3.2M10 13.6v.7"/>',
  back: '<path d="M15.5 10h-11M9 4.5 3.5 10 9 15.5"/>',
  external: '<path d="M11.5 4.5H15.5V8.5M15.5 4.5 9 11"/><path d="M14 12v3.5H4.5V6H8"/>',
  key: '<circle cx="7" cy="10" r="3.2"/><path d="M10.2 10h6.3M14.4 10v2.6M16.5 10v2"/>',
  eye: '<path d="M2.5 10S5.5 5 10 5s7.5 5 7.5 5-3 5-7.5 5-7.5-5-7.5-5Z"/><circle cx="10" cy="10" r="2.4"/>',
  'eye-off':
    '<path d="M4.2 4.2 15.8 15.8"/><path d="M8.2 8.3a2.4 2.4 0 0 0 3.4 3.4"/><path d="M6.2 6.3C3.9 7.6 2.5 10 2.5 10s3 5 7.5 5c1.2 0 2.2-.3 3.2-.8M13.6 13"/><path d="M9 5.1c.3 0 .7-.1 1-.1 4.5 0 7.5 5 7.5 5s-.7 1.2-2 2.4"/>',
  'user-plus':
    '<circle cx="8" cy="7" r="2.8"/><path d="M2.8 16c0-2.6 2.3-4.4 5.2-4.4 1 0 1.9.2 2.7.6"/><path d="M14.2 12v4.4M12 14.2h4.4"/>',
  refresh: '<path d="M16 6.5v4h-4"/><path d="M15.4 10.4A5.6 5.6 0 1 1 14 6.3"/>',
  roles:
    '<rect x="3" y="4.6" width="14" height="10.8" rx="2"/><circle cx="7.6" cy="9" r="1.9"/><path d="M4.9 13.6c.3-1.4 1.4-2.2 2.7-2.2s2.4.8 2.7 2.2M12.2 8.4h3.1M12.2 11.2h2"/>',
  badge:
    '<path d="M10 2.8 4.6 5v4.3c0 3.2 2.2 6.1 5.4 7.2 3.2-1.1 5.4-4 5.4-7.2V5z"/><path d="M7.4 9.4h5.2M7.4 12h3.2"/>',
  cloud:
    '<path d="M6.6 15.4a3.6 3.6 0 0 1-.5-7.16 4.4 4.4 0 0 1 8.36 1.06 3.05 3.05 0 0 1-.56 6.1z"/><path d="M8.4 11.6h3.4"/>',
  logout:
    '<path d="M12.5 6.2V4.6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v10.8a1 1 0 0 0 1 1h6.5a1 1 0 0 0 1-1v-1.6"/><path d="M8.4 10h8.2M14 7.4 16.6 10 14 12.6"/>',
  close: '<path d="M5.5 5.5l9 9M14.5 5.5l-9 9"/>',
  qr: '<rect x="3.5" y="3.5" width="5.5" height="5.5" rx="1"/><rect x="11" y="3.5" width="5.5" height="5.5" rx="1"/><rect x="3.5" y="11" width="5.5" height="5.5" rx="1"/><path d="M11 11h2.2v2.2H11zM14.3 14.3h2.2v2.2h-2.2z"/>',
  device: '<rect x="3" y="4.5" width="14" height="9" rx="1.5"/><path d="M7 16.5h6"/>',
};

export type IconName = keyof typeof PATHS;

export function Icon({
  name,
  size = 17,
  className,
}: {
  name: string;
  size?: number;
  className?: string;
}) {
  const path = PATHS[name] ?? PATHS['info']!;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...(className ? { className } : {})}
      dangerouslySetInnerHTML={{ __html: path }}
    />
  );
}
